import { Header } from '@components/Layout/components';
import { FooterFallback } from '@components/RemoteMicroFrontends/fallbacks';
import { FederatedErrorBoundary } from '@components/RemoteMicroFrontends/FederatedErrorBoundary';
import { BRIGHTPATH_HOME_URL } from '@constants/externalRoutes';
import { CoreBox, CoreButton, CoreTypography } from '@youscience/core';
import { ErrorInfo, lazy, Suspense } from 'react';
import { ErrorMessage, errorMessages, ErrorPageProps } from './constants';
import { sxStyles } from './Error.styles';

const Footer = lazy(() => import('brightpathHeader/Footer')) as React.FC<unknown>;

export const ErrorPage = ({ errorType }: ErrorPageProps) => {
  const errorMessage: ErrorMessage = errorMessages[errorType];

  const redirectToBPHome = () => {
    window.location.href = `${BRIGHTPATH_HOME_URL}/home`;
  };

  return (
    <>
      <Header />
      <CoreBox sx={sxStyles.container}>
        <CoreBox sx={sxStyles.content}>
          <CoreTypography sx={sxStyles.error}>{errorMessage.error}</CoreTypography>
          <CoreTypography sx={sxStyles.mainMessage}>{errorMessage.mainMessage}</CoreTypography>
          <CoreTypography sx={sxStyles.subMessage}>{errorMessage.subMessage}</CoreTypography>
          <CoreButton sx={sxStyles.button} onClick={redirectToBPHome}>
            Take me home
          </CoreButton>
        </CoreBox>
      </CoreBox>
      <Suspense fallback={null}>
        <FederatedErrorBoundary
          moduleName="brightpathFooter"
          fallback={<FooterFallback />}
          onError={(error: Error, errorInfo: ErrorInfo) => {
            console.error('Failed to load Footer:', error, errorInfo);
          }}
        >
          <Footer />
        </FederatedErrorBoundary>
      </Suspense>
    </>
  );
};
